/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Running_CoachingInputs */

const en_service_type_running_coaching = /** @type {(inputs: Service_Type_Running_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running coaching`)
};

const pl_service_type_running_coaching = /** @type {(inputs: Service_Type_Running_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening biegowy`)
};

/**
* | output |
* | --- |
* | "Running coaching" |
*
* @param {Service_Type_Running_CoachingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_running_coaching = /** @type {((inputs?: Service_Type_Running_CoachingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Running_CoachingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_running_coaching(inputs)
	return en_service_type_running_coaching(inputs)
});